/**
 * Internal dependencies
 */
import './style.scss';
import { OptimizationScore } from './optimization-score';
import { Quota } from './quota';

export function OptimizationScoreAndQuota(): JSX.Element {
	return (
		<div className="nab-overview-optimization-score-and-quota nab-overview-card">
			<div className="nab-overview-optimization-score-and-quota__row">
				<OptimizationScore />
				<Quota />
			</div>
		</div>
	);
}
